import { Box, MenuItem } from '@mui/material';

import ActiveIcon from '../../../../../components/svgs/ActiveIcon';
import CompletedStatusIcon from '../../../../../components/svgs/CompletedStatusIcon';
import EditStatusIcon from '../../../../../components/svgs/EditStatusIcon';
import InProgressStatusIcon from '../../../../../components/svgs/InProgressStatusIcon';
import ReadonlyStatusIcon from '../../../../../components/svgs/ReadonlyStatusIcon';
import { ENTITY_PREFIX } from '../../../../../constants';
import { formatEntityId } from '../../../../../helpers';
import { TREATMENT_PLAN_V3_STATUS } from '../constants';
import {
  SELECT_PLAN_ROW_ICON_SX,
  SELECT_PLAN_ROW_STATUS_SX,
  TP_OPTIONS_SUBMENU_ROW_SX,
} from '../styles';
import { hasPlanStatus } from '../utils';

import type { ReactNode } from 'react';
import type { SelectPlanSubmenuRowProps } from './types';

export default function SelectPlanSubmenuRow({
  treatmentPlan,
  isActive,
  isCurrent,
  tpStatusIdByLabel,
  onSelect,
}: SelectPlanSubmenuRowProps) {
  const planId = treatmentPlan.id;

  let statusIcon: ReactNode = null;
  if (hasPlanStatus(treatmentPlan, tpStatusIdByLabel, [TREATMENT_PLAN_V3_STATUS.STARTED])) {
    statusIcon = <InProgressStatusIcon />;
  } else if (hasPlanStatus(treatmentPlan, tpStatusIdByLabel, [TREATMENT_PLAN_V3_STATUS.EDITING])) {
    statusIcon = <EditStatusIcon />;
  } else if (
    hasPlanStatus(treatmentPlan, tpStatusIdByLabel, [TREATMENT_PLAN_V3_STATUS.COMPLETED])
  ) {
    statusIcon = <CompletedStatusIcon />;
  } else if (
    hasPlanStatus(treatmentPlan, tpStatusIdByLabel, [TREATMENT_PLAN_V3_STATUS.READ_ONLY])
  ) {
    statusIcon = <ReadonlyStatusIcon />;
  }

  const handleClick = () => onSelect(planId);

  return (
    <MenuItem
      data-testid="selectPlan"
      disabled={isCurrent}
      sx={TP_OPTIONS_SUBMENU_ROW_SX}
      onClick={handleClick}
    >
      <Box sx={SELECT_PLAN_ROW_ICON_SX}>{isActive ? <ActiveIcon /> : null}</Box>
      <Box sx={{ flexGrow: 1 }}>{formatEntityId(planId, ENTITY_PREFIX.TreatmentPlan)}</Box>
      <Box sx={SELECT_PLAN_ROW_STATUS_SX}>{statusIcon}</Box>
    </MenuItem>
  );
}
